import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { FeatureFlagDataModel, FeatureFlagUpdateRequest } from '../models/feature-flag.model';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  constructor(
    private readonly httpClient: HttpClient,
    private cookieService: CookieService,
    private readonly router: Router
  ) {}

  getFeatureFlags(source) {
    return this.httpClient.get<FeatureFlagDataModel[]>(
      `${environment.customerGateway}/feature-flags?source=${source}`,
      {
        headers: { Authorization: this.cookieService.get('X-Access-Token') },
      }
    );
  }

  updateFeatureFlag(request: FeatureFlagUpdateRequest[]) {
    return this.httpClient.put(`${environment.customerGateway}/feature-flags`, request, {
      headers: { Authorization: this.cookieService.get('X-Access-Token') },
    });
  }
}
